import { render, staticRenderFns } from "./goal_edit.vue?vue&type=template&id=a4d9eb38&scoped=true&"
import script from "./goal_edit.vue?vue&type=script&lang=js&"
export * from "./goal_edit.vue?vue&type=script&lang=js&"
import style0 from "./goal_edit.vue?vue&type=style&index=0&id=a4d9eb38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d9eb38",
  null
  
)

export default component.exports